import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { CurrencySelect } from 'web-ui-components/lib/finance/currency';
import { Field, FieldHeader } from 'web-ui-components/lib/molecules/forms';
import { Checkbox } from 'web-ui-components/lib/atoms/forms';
import content, { contentPropTypes } from './CurrencySelector.content';
import withContent from '../../../../containers/withContent';

export const CurrencySelector = ({
	currencyList,
	content: { header, description, defaultCurrencyLabel },
	onCurrencySelection,
	selectedCurrency,
	onSettingDefaultCurrency,
	isDefaultCurrency,
	showDefaultCurrency,
	isFromAccountExoticCurrency,
}) => (
	<div>
		<Field>
			<FieldHeader name="currency-select" titleText={header} description={description} />
		</Field>
		<CurrencySelect
			currencies={currencyList}
			onChange={onCurrencySelection}
			selectedId={selectedCurrency}
			isDisabled={isFromAccountExoticCurrency}
		/>
		{showDefaultCurrency && (
			<Checkbox
				checked={isDefaultCurrency}
				id="defaultCurrency"
				label={defaultCurrencyLabel}
				onChange={onSettingDefaultCurrency}
				fullWidth
			/>
		)}
	</div>
);

CurrencySelector.propTypes = {
	content: PropTypes.shape(contentPropTypes),
	currencyList: PropTypes.arrayOf(PropTypes.shape({})),
	onCurrencySelection: PropTypes.func.isRequired,
	selectedCurrency: PropTypes.string.isRequired,
	onSettingDefaultCurrency: PropTypes.func.isRequired,
	isDefaultCurrency: PropTypes.bool.isRequired,
	showDefaultCurrency: PropTypes.bool.isRequired,
	isFromAccountExoticCurrency: PropTypes.bool.isRequired,
};
export default compose(withContent({ content }))(CurrencySelector);
